import * as request from '../../request'
import * as serializers from './serializers'

// eslint-disable-next-line import/prefer-default-export
export const acceptTerm = async (id) => {
  try {
    const res = await request.patch(`v1/users/me/term/${id}/accept`)

    return serializers.acceptTerm(res)
  } catch (err) {
    return Promise.reject(err)
  }
}
